import React from "react";
import ErrorSVG from "../../../assets/banner/error.svg";
const Error = () => {
  return (
    <div className="flex justify-center items-center w-full h-[800px]">
      <img className="w-full h-full" src={ErrorSVG} alt="" />
    </div>
  );
};

export default Error;
